import { Box, Container } from '@mui/material';
import PageHeader from 'components/common/PageHeader/PageHeader';
import InviteUsersButton from 'components/user/InviteUsersButton/InviteUsersButton';
import Users from 'components/user/Users/Users';
import { UsersProvider } from 'context/UsersContext';
import useGlobalStyles from 'styles/globalStyles';


export default function UsersPage() {
  const globalStyles = useGlobalStyles();

  return (
    <UsersProvider>
      <Box className={globalStyles.container} p={3}>
        <Box>
          <PageHeader
            title={'Users'}
            buttons={[
              <InviteUsersButton key='invite' />
            ]}
          />
        </Box>

        <Box mt={3}>
          <Users />
        </Box>
      </Box>
    </UsersProvider>
  )
}

